import {
  GET_ALL_OFFICE_SERVERS_PENDING,
  GET_ALL_OFFICE_SERVERS_SUCCESS,
  GET_ALL_OFFICE_SERVERS_ERROR,
  UPDATE_OFFICE_SERVERS,
  RESET_GET_ALL_OFFICE_SERVERS,
  GetAllOfficeServersState,
  GetAllOfficeServersActionType,
} from "./types";

const initialState: GetAllOfficeServersState = {
  getAllOfficeServersPending: false,
  getAllOfficeServersError: false,
  officeServers: null
}

export function GetAllOfficeServersReducer(
  state: GetAllOfficeServersState = initialState,
  action: GetAllOfficeServersActionType
): GetAllOfficeServersState {
  switch (action.type) {

    case GET_ALL_OFFICE_SERVERS_PENDING: {
      return {
        ...state,
        getAllOfficeServersPending: true,
      };
    }

    case GET_ALL_OFFICE_SERVERS_SUCCESS: {
      const { payload } = action;
      const { officeServers } = payload;

      return {
        ...state,
        getAllOfficeServersPending: false,
        getAllOfficeServersError: false,
        officeServers,
      };
    }

    case GET_ALL_OFFICE_SERVERS_ERROR: {
      return {
        ...state,
        getAllOfficeServersPending: false,
        getAllOfficeServersError: true,
      };
    }

    case UPDATE_OFFICE_SERVERS: {
      const { payload } = action;
      const { officeServers } = payload;

      return {
        ...state,
        officeServers,
      };
    }

    case RESET_GET_ALL_OFFICE_SERVERS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
